<template>
  <div  v-redirect-if-no-permission:DISPATCHING class="main-container">
    <button
      @click="selectedTab = 'INSTANT'"
      :class="selectedTab == 'INSTANT' ? 'selected' : ''"
    >
      {{ $t("dispatching.requests.instantOrders") }}
    </button>
    <button
      @click="selectedTab = 'RESERVATION'"
      :class="selectedTab == 'RESERVATION' ? 'selected' : ''"
      style="margin-left: 10px"
    >
      {{ $t("dispatching.requests.reservation") }}
    </button>
    <button
      @click="selectedTab = 'SHORT'"
      :class="selectedTab == 'SHORT' ? 'selected' : ''"
      style="margin-left: 10px"
    >
    {{ $t("dispatching.requests.shortReservation") }}
    </button>
    <!-- <PhoneOrders style="margin-left: 10px; float: right"></PhoneOrders> -->
    <router-link v-if="this.$store.state.user.roles[0].name != 'Goverment'"  :to="{ name: 'PhoneBooking' }"><button  class="phone-booking-button">{{ $t("dispatching.requests.newOrder") }}</button></router-link>
    <component :is="selectedTab"></component>
  </div>
</template>

<script>
import InstantOrders from "@/components/dispatching/InstantOrders.vue";
import ReservationOrders from "@/components/dispatching/ReservationOrders.vue";
import ShortReservationOrders from "@/components/dispatching/ShortReservationOrders.vue";

export default {
  name: "Requests",
  title() {
    return this.$t("dispatching.requests.title");
  },
  components: {
    INSTANT: InstantOrders,
    RESERVATION: ReservationOrders,
    SHORT: ShortReservationOrders,
  },
  data() {
    return {
      selectedTab: "INSTANT",
    };
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  width: 100%;
  height: 100%;
  padding: 28px 36px;
  float: left;
  font-family: Poppins !important;

  button {
    float: left;
    padding: 14px 20px;
    border-radius: 8px;
    box-shadow: 0px 0px 6px rgba(0, 11, 138, 0.08);
    background: white;
    outline: none;

    &.selected {
      box-shadow: inset 0px 0px 0px 1px #d71010;
    }
  }

  .phone-booking-button {
    float: right;
    background: #d71010;
    color: white;
  }
}
</style>
